import { AutocompleteItem, TmdxAvatar, User } from '@ds';
import { Hospital, TXCenter } from '@/api/apis/facilities';
import { getLocationAddress } from '@/utils/helpers';

type FacilityAutocompleteItemProps = Hospital | TXCenter;

export const getRenderFacilityAutocompleteItem =
  (resolveSubdivisionName: (stateCode?: string | null, countryCode?: string | null) => string | undefined) =>
  ({ id, name, code, location, logoPath }: FacilityAutocompleteItemProps) => (
    <AutocompleteItem key={id} textValue={name}>
      <User
        avatarProps={{
          icon: (
            <TmdxAvatar
              size="xl"
              radius="xl"
              type="facility"
              name={code || resolveSubdivisionName(location?.state, location?.country)}
              src={logoPath}
              fallbackInitials={false}
            />
          ),
        }}
        name={name}
        description={getLocationAddress(location, resolveSubdivisionName)}
        classNames={{
          base: '[&>*:not(.user-wrapper)]:w-12 [&>*:not(.user-wrapper)]:h-12 [&>*:not(.user-wrapper)]:w-12 [&>*:not(.user-wrapper)]:rounded-2xl [&>*:not(.user-wrapper)]:shrink-0',
          wrapper: 'user-wrapper text-wrap',
        }}
      />
    </AutocompleteItem>
  );
